import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { dividerConfig } from '../../constants';
export var getDividerStyles = props => {
  var height = props.height,
    color = props.color,
    shadowColor = props.shadowColor,
    isVertical = props.isVertical,
    isDarkMode = props.isDarkMode,
    darkModeColor = props.darkModeColor,
    darkModeShadowColor = props.darkModeShadowColor;
  var dividerBgColor = isDarkMode ? darkModeColor : color;
  var dividerShadowColor = isDarkMode ? darkModeShadowColor : shadowColor;
  var borderStyles = Object.assign(Object.assign({
    borderWidth: height / 2,
    borderTopWidth: 0,
    borderLeftWidth: 0
  }, !isVertical && {
    borderBottomColor: dividerShadowColor,
    borderRightWidth: 0
  }), isVertical && {
    borderRightColor: dividerShadowColor,
    borderBottomWidth: 0
  });
  return StyleSheet.create({
    container: Object.assign(Object.assign({}, dividerShadowColor && borderStyles), {
      height: isVertical ? '100%' : height,
      width: isVertical ? height : '100%',
      backgroundColor: dividerBgColor
    })
  });
};
export var getDividerProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(dividerConfig === null || dividerConfig === void 0 ? void 0 : dividerConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.divider) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};